// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__NH8Gl","content":"ManualTimeModal_content__2JZad"};